var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_c('h1',[_vm._v(_vm._s(_vm.$t('app-title', {environment: this.env})))]),(this.isLoggedIn)?_c('div',{staticClass:"actions"},[_c('Search',{staticClass:"search"}),_c('UserInfo',{staticClass:"user-info"})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }